import styled from 'styled-components';

export const ButtonBox = styled.div<{ isOpenFilter: boolean }>`
  display: ${({ isOpenFilter }) => (isOpenFilter ? 'flex' : 'none')};
  gap: 1.2rem;
  padding: 1.2rem 2rem;
`;
export const FliterBox = styled.div`
  padding: 0 2rem;
  margin-bottom: 3.2rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;
export const FliterLabel = styled.p`
  display: flex;
  gap: 2.4rem;
  margin-bottom: 0.4rem;
`;
export const OptionBox = styled.div`
  display: flex;
`;
export const OptionLabel = styled.p`
  width: 100%;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  overflow-y: auto;
  margin-top: 2rem;
`;

export const Header = styled.div<{ isOpenFilter: boolean }>`
  display: ${({ isOpenFilter }) => (isOpenFilter ? 'flex' : 'none')};
  gap: 0.8rem;
  padding: 1.5rem 2rem;
  .title {
    width: 100%;
    text-align: center;
    font-size: 1.8rem;
  }

  .right {
    width: 2.4rem;
  }
`;

export const Container = styled.div<{ isOpenFilter: boolean }>`
  width: 100%;
  height: ${({ isOpenFilter }) => (isOpenFilter ? '100%' : '0')};
  background-color: #18161c;
  position: absolute;
  left: 0;
  z-index: 100;
  top: ${({ isOpenFilter }) => (isOpenFilter ? '0' : '100%')};
  transition: ${({ isOpenFilter }) =>
    isOpenFilter ? 'top 0.6s ease-out' : 'none'};

  display: flex;

  flex-direction: column;
`;
